/** 繁體中文服務條款（正文請於本檔補充） */
export const termsTitle = 'BILION PASS 服務條款';

export const termsBody = `
本使用條款（以下簡稱「本條款」）
本條款旨在規範由 Japan DX 株式會社（以下簡稱「本公司」）營運之 BILION PASS 網站（以下簡稱「本網站」）上所提供之各項服務（以下簡稱「本服務」）之使用條件。本網站使用者（以下簡稱「使用者」）於使用本服務時，應遵守本條款之約定。
第一條（本條款之適用範圍）
本條款適用於所有使用本服務之使用者。
除本條款外，本公司就本服務另行訂定之各項規則，均構成本條款之一部分。
若本條款規定與前項所述本公司另行訂定之各項規則內容不一致時，以該等另行訂定之規則內容優先適用。
第二條（條款之變更）
本公司得無需取得使用者同意，逕行對本條款為條文之新增、修改、刪除等調整。屆時本服務之使用條件，以變更後之本條款為準。
除本公司另行訂定者外，變更後之條款自於本網站公告之日起發生效力；使用者於條款變更後繼續使用本服務者，視為同意變更後之本條款。
第三條（使用環境）
使用本網站須連接網際網路（Web）。使用者應自行負責並負擔費用，準備所需之設備、軟體、通訊工具等，並妥善安裝及操作。
本公司不參與使用者前述之準備作業及操作方式，亦不負任何相關責任。
第四條（智慧財產權）
本網站及本網站刊載之著作等（包括但不限於文字、照片、地圖、繪畫、設計圖、圖表、電影、音樂、程式、資料庫等著作，以及衍生著作、編輯著作）之著作權，歸屬於本公司及其他權利人所有。
未經本公司及其他權利人同意，嚴禁對該等著作為重製、公開上演、演奏、上映、公眾傳播（含公開傳輸）、口述、展示、發行、轉讓、出租、翻譯、改作、變更等一切行為。
本網站及本服務所使用之商號、商品名稱、服務名稱、標誌等，為本公司及其他權利人之註冊商標或商標。未經本公司及其他權利人同意，不得擅自使用該等商標。
第五條（本網站之連結）
使用者不得以符合下列任一情形，或有該等疑慮之方式設定指向本網站之連結：
① 以營利為目的者
② 對圖片為直接連結者（關於圖片顯示）
③ 有造成本公司社會或經濟上損失之虞者
④ 將本網站嵌入獨立框架內為連結者
⑤ 連結至第三人享有著作權且禁止連結之文章者
⑥ 其他經本公司判斷有礙本服務營運之虞者
第六條（會員註冊）
本網站得無需註冊為會員（指完成會員註冊程序並使用本服務之使用者，下同）逕行使用，但使用本服務部分功能時，須完成會員註冊。
辦理會員註冊時，應遵守下列條件。若違反下述規定，或本公司判斷使用者未提供真實且正確之資料時，本公司得刪除該會員之註冊資訊，並拒絕其日後使用本服務。
① 會員註冊表格應由申請人本人填寫自身真實且正確之資料，並透過本網站傳送至本公司。
② 為確保註冊資訊恆為真實且正確，資料內容有變更時，應適時修正。同時，會員應妥善保管自身之密碼。
會員註冊時所登錄之註冊資訊，以及使用本服務時所提供之資訊，其所有權歸屬本公司。
本公司除得依本條款約定使用外，亦得依本公司訂定之隱私權政策，於與本服務相關之範圍內，或為本服務使用以外之目的使用該等資訊。
本公司向第三人揭露該等資訊時，應事先取得該會員之同意。
本公司得基於會員提供之個人資料，透過本服務以電子郵件、網站公告等方式，向各會員提供個人化資訊，以及本公司及業務合作夥伴之商品、服務介紹等。
本公司得為供本公司或業務合作夥伴經營參考，請求會員協助問卷調查、訪談等事項。
會員有下列任一情形者，喪失會員資格，視為自動退會：
① 本公司撤銷對該會員之入會許可者
② 該會員違反本條款任一條文，經本公司決議除名者
③ 該會員依規定程序向本公司申請退會者
本公司判斷有必要對會員為聯繫或通知時，原則上以電子郵件傳送至登錄之電子信箱為之。
第七條（會員資訊之處理方式）
會員註冊時登錄之資訊及本公司以其他方式取得之會員相關資訊，將依本公司訂定之隱私權政策處理。
第八條（禁止事項）
使用者於使用本網站時，禁止為下列行為：
① 竄改、刪除經由本網站可使用之資訊
② 嘗試非法存取與本網站連接之其他電腦系統或網路
③ 侵害或有侵害之虞其他使用者、第三人或本公司之著作權、商標權等智慧財產權之行為
④ 毀損或有毀損之虞其他使用者、第三人或本公司之名譽或信用之行為
⑤ 侵害或有侵害之虞其他使用者、第三人或本公司之財產、隱私權、肖像權、公開權之行為
⑥ 擅自使用、轉讓、販賣其他使用者之電子信箱等資訊之行為
⑦ 未經本公司同意，將 AI 生成內容為商業目的轉載、販賣之行為
⑧ 非法重製、竄改優惠券或轉售優惠券予第三人之行為
⑨ 破壞或妨礙伺服器或網路功能之行為
⑩ 以營業活動或營利為目的之行為，及為該等目的為準備之行為
⑪ 使用或提供電腦病毒等有害程式，或有該等疑慮之行為
⑫ 假冒其他使用者、第三人或本公司使用本服務之行為
⑬ 對其他使用者、第三人或本公司造成不利益或損害，或有該等疑慮之行為
⑭ 違反公序良俗，或有該等疑慮之行為
⑮ 犯罪行為或與犯罪相關之行為，或有該等疑慮之行為
⑯ 其他違反法律、命令或條例，或有該等疑慮之行為
⑰ 種族歧視之行為
⑱ 妨礙本網站營運之行為
⑲ 助长前各款所列行為之行為
⑳ 其他經本公司判斷不適當之行為
第九條（損害賠償責任）
使用者因違反本條款約定，致其他使用者及本公司受有損害者，應賠償其損害（含律師費）。
若因違反本條款致與第三人發生糾紛時，使用者應自行負責並負擔費用解決，不得使本公司受有損害或困擾。
第十條（免責事項）
本公司於提供本服務時，就下列事項不為任何保證：
① 完全滿足使用者之需求
② 刊載之資訊具即時性、正確性、合法性、實用性、完整性
③ 不發生服務中斷、系統錯誤、漏洞、瑕疵等
④ 瑕疵將獲修復
⑤ 無電腦病毒及其他有害程式
⑥ 使用者不因使用或無法使用本服務而受有損害
本服務目前提供觀光及旅行相關資訊與功能，為提升服務品質，本公司得未事先通知，逕行對該等內容為新增、變更、暫停、刪除等調整。
本公司於下列情形下，得未事先通知暫停或中止本網站之營運：
① 須定期或緊急變更資訊、功能或系統者
② 須定期或緊急檢查系統或設備者
③ 因天災、地震、停電等原因致無法持續提供本服務者
④ 其他因不可預期之事由致有停止、終止必要者
無論任何理由，本公司就使用者因使用本服務所生之任何損害，以及因本服務資訊、功能變更或營運暫停、中止所生之任何損害，均不負責任。
自本網站連出或連入本網站之非本公司營運之第三人網站（以下簡稱「連結網站」）內容，由各連結網站之營運者自行負責管理。
使用者使用連結網站時，應遵守各連結網站之使用條件及著作權處理等相關規定。
本公司就連結網站之內容，及使用者因使用連結網站所生之任何損害，均不負責任。
本公司因天災地變等不可抗力、營運上不得已之事由或營運策略判斷，得終止本服務之全部或一部。
第十一條（禁止轉讓）
使用者不得將受領本服務之權利為轉讓、買賣、名義變更、設定質權或其他擔保等行為。會員註冊具一身專屬性。
第十二條（諮詢）
關於本服務之諮詢，應依本公司所定方式為之。
關於使用者之意見、諮詢等
未經本公司事先書面同意，使用者禁止對本公司就其意見、諮詢所為之電子郵件等回覆為重製、公眾傳播、轉寄、轉載等，或向第三人揭露。
第十三條（準據法・裁判管轄）
本條款之解釋，以日本法為準據法。
因本服務涉訟者，以本公司總公司所在地之管轄法院為專屬合意管轄法院。
以上
本公司就本服務所訂定之各項規定
AI 旅行規劃產生服務
本服務利用人工智慧（AI），依使用者需求產生旅行規劃。
AI 產生之規劃（路線、所需時間、設施資訊等），不保證其正確性、即時性或完整性。實際旅行時，使用者應自行事先確認大眾運輸營運狀況及設施營業時間。
其他服務
關於適用於本服務之條件，請參閱自本網站移轉至該頁面所刊載之條款。
以上
`;
